// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Stack } from "@mui/system";
import { useMemo, useState } from "react";
import { TrendingUp, AccountBalance, Close as CloseIcon, ShoppingCart, Cancel, Replay, ArrowForwardIos } from "@mui/icons-material";
import { Button } from "../atoms";
import { PieChart } from "react-minimal-pie-chart";
import {
  IDashboardTransaction,
  useGetDashboardTransactionDetail,
} from "../../hooks";
import { useUserInfo } from "../../store/User.state";

const Dates = [
  { label: "Günlük", value: "DAILY" },
  { label: "Haftalık", value: "WEEKLY" },
  { label: "Aylık", value: "MONTHLY" },
  { label: "Yıllık", value: "YEARLY" },
];

export type TransactionItemProps = {
  description: string;
  value: string;
  bankCode?: string;
  key2: string;
  onDetailClick?(): void;
};

const TransactionItem = ({ description, value, key2, bankCode, onDetailClick, userInfo }: TransactionItemProps) => {
  const renderIcon = () => {
    switch (description) {
      case 'Satış':
        return <ShoppingCart color="primary" />;
      case 'İptal':
        return <Cancel color="error" />;
      case 'İade':
        return <Replay color="warning" />;
      default:
        return null;
    }
  };

  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, height: '100%' }}>
        <Stack spacing={1}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="h6" color="text.secondary">{description}</Typography>
            </Stack>
            {(bankCode && userInfo?.userType == 1) && (
              <Button
                onClick={onDetailClick}
                variant="text"
                size="small"
                endIcon={<ArrowForwardIos sx={{ fontSize: 12 }} />}
                sx={{ textTransform: 'none' }}
                text="Detay"
              />
            )}
          </Stack>
          <Typography variant="h4" fontWeight="bold">{key2}</Typography>
          <Typography variant="body2" color="text.secondary">{value} İşlem</Typography>
        </Stack>
      </Paper>
    </Grid>
  );
};

export type DashboardWidgetProps = {
  items: Array<IDashboardTransaction>;
  onDateClick(value: "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY"): void;
  widgetTitle?: string;
};

export const DashboardWidget = ({
  items,
  onDateClick,
  widgetTitle
}: DashboardWidgetProps) => {
  const [userInfo] = useUserInfo();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [isOpen, setIsOpen] = useState(false);
  const { data: transactionDetail, mutate: getDashboardTransactionDetail } =
    useGetDashboardTransactionDetail();
  const [date, setDate] = useState<"DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY">(
    "DAILY"
  );
  const handleOpenDetail = (item: IDashboardTransaction) => {
    setIsOpen(true);
    item?.bankCode &&
      getDashboardTransactionDetail({
        period: date,
        bankCode: item.bankCode,
      });
  };
  const filteredItems = useMemo(() => {
    if (userInfo?.merchantId == 0) {
      return items;
    } else {
      return items?.filter((item) => item?.merchantId == userInfo?.merchantId);
    }
  }, [items, userInfo?.merchantId]);

  const formatNumberToCurrency = (numberStr) => {
    if (numberStr === null || numberStr === undefined) {
      return "-";
    }

    const stringValue = String(numberStr);
    let adjustedNumber = parseFloat(stringValue.replace(',', '.'));

    // Sayıyı belirtilen formatta formatlıyoruz
    let formattedNumber = new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(adjustedNumber);

    return formattedNumber
  }

  const renderMoney = (money: string) => {
    switch (money) {
      case "949":
        return "TL";
      case "840":
        return "USD";
      case "978":
        return "EUR"
      default:
        return "-";
    }
  }

  const isDesktopH = window.innerWidth >= 1500;
  const isMediumScreen = useMediaQuery(
    "(min-width: 900px) and (max-width: 1024px)"
  );
  return (
    <>
      <Stack
        flex={1}
        sx={{ boxShadow: 2, borderRadius: 3, backgroundColor: '#fff' }}
        width="100%"
        px={isDesktop ? 3 : 1}
        py={isDesktop ? 4 : 2}
      >
        <Stack
          width="100%"
          direction={isDesktop ? "row" : "column"}
          justifyContent={isDesktop ? "space-between" : "flex-start"}
          alignItems={isDesktop ? "center" : "flex-start"}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            {widgetTitle === 'Satış Tipi' && <TrendingUp />}
            {widgetTitle === 'Banka Satış' && <AccountBalance />}
            <Typography mb={isDesktop ? 0 : 2} variant="h4">
              {widgetTitle}
            </Typography>
          </Stack>
          <Stack
            spacing={1}
            sx={{ backgroundColor: "primary.extraLighter" }}
            direction="row"
            flexWrap="wrap"
            flex={isDesktop ? "" : 1}
            justifyContent={isDesktop ? "flex-start" : "center"}
            borderRadius={2}
            p={1}
          >
            {Dates?.map((item: any) => {
              const handleActive = () => {
                setDate(item?.value);
                onDateClick(item?.value);
              };
              return (
                <Button
                  onClick={handleActive}
                  sx={{
                    backgroundColor:
                      item?.value === date ? "primary.main" : null,
                    color: item?.value === date ? "#FFF" : null,
                    mb: isDesktop ? 0 : 1,
                    height: 38,
                  }}
                  text={item?.label}
                />
              );
            })}
          </Stack>
        </Stack>
        <Grid container spacing={2} mt={3}>
          {filteredItems?.length > 0 ? (
            filteredItems?.map((item, index) => (
              <TransactionItem
                userInfo={userInfo}
                key={`${index}-${item?.key}-${item?.description}-${item?.value}`}
                bankCode={item?.bankCode}
                description={item?.description}
                value={item?.value}
                key2={`${formatNumberToCurrency(item?.total)} ${renderMoney(item?.key)}`}
                onDetailClick={() => handleOpenDetail(item)}
              />
            ))
          ) : (
            <Grid item xs={12}>
              <Paper elevation={2} sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}>
                <Typography variant="h6" color="text.secondary">Veri Bulunamadı</Typography>
              </Paper>
            </Grid>
          )}
        </Grid>
      </Stack>
      {isOpen && (
        <Dialog open={isOpen} onClose={() => setIsOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Detay</Typography>
              <IconButton onClick={() => setIsOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <Stack flex={1} px={4}>
              <Stack height={220}>
                {transactionDetail?.data ? (
                  <PieChart
                    lineWidth={32}
                    data={transactionDetail?.data?.map((transaction) => {
                      return {
                        title: transaction?.value,
                        value: Number(transaction?.total.replace(",", ".")),
                        color:
                          transaction?.description === "Satış"
                            ? "#00B0A6"
                            : transaction?.description === "İptal"
                              ? "#EEAB00"
                              : "#F5004A",
                      };
                    })}
                  />
                ) : null}
              </Stack>
              <Stack spacing={2} pt={4}>
                {transactionDetail?.data?.map((transaction) => (
                  <Stack
                    alignItems="center"
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Stack
                      flex={1}
                      spacing={2}
                      alignItems="center"
                      direction="row"
                    >
                      <Box
                        bgcolor={
                          transaction?.description === "Satış"
                            ? "#00B0A6"
                            : transaction?.description === "İptal"
                              ? "#EEAB00"
                              : "#F5004A"
                        }
                        width="16px"
                        height="16px"
                        borderRadius={2}
                      />
                      <Typography color="#41414D" variant="h5">
                        {transaction?.description}
                      </Typography>
                    </Stack>
                    <Typography
                      fontSize={14}
                      color="#41414D"
                      textAlign="right"
                      width={55}
                    >{`${transaction?.value} adet`}</Typography>
                    <Typography
                      fontSize={14}
                      color="#41414D"
                      flex={1}
                      textAlign="right"
                    >{`${formatNumberToCurrency(transaction?.total)} TL`}</Typography>
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
